/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H217483 on 1/15/2019.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {FormattedMessage, injectIntl} from 'react-intl';
import {Button, Modal, Select} from '@scuf/common';
import * as FaultActions from "../FaultActions";
import * as SecurityActions from '../../security/SecurityActions'
import {ACCESS, FAULT_ACTIONS, FAULT_STATES, isClosedState} from "./FaultsConst"
import Loader from '../../common/Loader'
import {faultCloseModel} from '../../model/Fault'
import {verifyAirtimeException} from '../../utils/Helpers'
import {showNotification} from "../../common/ToastNotification";
import UsersSelect from './UsersSelect'
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import {userHasActivity} from "../../security/SecurityUtils";
import CloseFaultModal from "./CloseFaultModal"

/**
 * Dropdown button with fault condition actions that is on Fault Detail page as well as Troubleshooting page
 */
class ActionsDropdown extends React.Component {
    constructor(props) {
        super(props)

        const {intl} = this.props

        this.state = {
            closeModalOpen: false,
            assigneeModalOpen: false,
            assignee: this.props.fault.details.assignedUser !== null ? this.props.fault.details.assignedUser.id : null,
            errors:[],
        }

        this.faultCloseModel = faultCloseModel(intl)

        this.changeFaultState = this.changeFaultState.bind(this)
        this.submitSetAssignee = this.submitSetAssignee.bind(this)

        //mapping of fault states to possible workflow actions
        this.stateActions = this.setUpStateMapping();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // User has been changed directly with link without opening modal
        if (prevProps.fault.details.assignedUser !== null && this.props.fault.details.assignedUser &&
            prevProps.fault.details.assignedUser.id !== this.props.fault.details.assignedUser.id &&
            !this.state.assigneeModalOpen)
        {
            this.setState({assignee: this.props.fault.details.assignedUser.id})
        }
    }

    setUpStateMapping() {
        const {security} = this.props
        if(userHasActivity(security.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            return {
                'NEW': [
                    {
                        action: FAULT_ACTIONS.DELETE,
                        available: true,
                    },
                    {
                        action: FAULT_ACTIONS.CLOSE,
                        available: false,
                    }],
                'IN_PROGRESS': [
                    {
                        action: FAULT_ACTIONS.DELETE,
                        available: false,
                    },
                    {
                        action: FAULT_ACTIONS.CLOSE,
                        available: true,
                    }],
                'VERIFICATION': [
                    {
                        action: FAULT_ACTIONS.DELETE,
                        available: false,
                    },
                    {
                        action: FAULT_ACTIONS.CLOSE,
                        available: true,
                    }],
                'CLOSED_RESOLVED': [],
                'DELETED': [],
                'CLOSED_DUE_TO_LDI_IMPORT': [],
                'CLOSED_DUE_TO_INACTIVITY': [],
            }
        } else {
            return {
                'NEW': [{
                    action: FAULT_ACTIONS.DELETE,
                    available: true,
                },
                    {
                        action: FAULT_ACTIONS.PUT_ON_HOLD,
                        available: false,
                    },
                    {
                        action: FAULT_ACTIONS.CLOSE,
                        available: false,
                    }],
                'IN_PROGRESS': [{
                    action: FAULT_ACTIONS.DELETE,
                    available: false,
                },
                    {
                        action: FAULT_ACTIONS.PUT_ON_HOLD,
                        available: true,
                    },
                    {
                        action: FAULT_ACTIONS.CLOSE,
                        available: true,
                    }],
                'ON_HOLD': [
                    {
                        action: FAULT_ACTIONS.DELETE,
                        available: false,
                    },
                    {
                        action: FAULT_ACTIONS.START,
                        available: true,
                    },
                    {
                        action: FAULT_ACTIONS.CLOSE,
                        available: false,
                    },
                ],
                'VERIFICATION': [{
                    action: FAULT_ACTIONS.DELETE,
                    available: false,
                },
                    {
                        action: FAULT_ACTIONS.PUT_ON_HOLD,
                        available: false,
                    },
                    {
                        action: FAULT_ACTIONS.CLOSE,
                        available: true,
                    }],
                'CLOSED_RESOLVED': [],
                'DELETED': [],
                'CLOSED_DUE_TO_LDI_IMPORT': [],
                'CLOSED_DUE_TO_INACTIVITY': [],
            }
        }
    }

    changeFaultState(state, comment) {
        const {fault} = this.props
        return this.props.FaultActions.setFaultState(fault.assetId, fault.faultId, state, undefined, comment).then(() => {
            this.props.reloadFaultCondition()
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    fetchCreatedFaults() {
        const {fault} = this.props
        this.props.FaultActions.fetchCreatedFaults(fault.assetId, fault.faultId).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        })
    }

    assigneeModal() {
        const {intl, fault} = this.props
        return (
            <Modal closeIcon={false} onClose={() => this.setState({assigneeModalOpen: false})} open={this.state.assigneeModalOpen} closeOnDimmerClick={false} className="assign-modal">
                <Modal.Header>
                    <FormattedMessage id="fault.detail.action.assignee.title"/>
                </Modal.Header>
                <Modal.Content scrolling={false}>
                        <UsersSelect selectedUser={this.state.assignee}
                                     childFleetId={fault.details.asset.fleetId}
                                     label={intl.formatMessage({id: "fault.detail.label.user"})}
                                     onChange={(userId) => this.setState({assignee: userId})}
                                     fluid/>
                </Modal.Content>
                <Modal.Footer>
                    <div className="assignModal-buttons">
                        <Button className="mobile-max-width-button" content={intl.formatMessage({id: "fault.detail.action.cancel"})} onClick={() => this.setState({assigneeModalOpen: false})} size="medium" type="secondary" />
                        <Button className="mobile-max-width-button" content={intl.formatMessage({id: "fault.detail.action.assign.submit"})} onClick={this.submitSetAssignee} size="medium" type="primary" />
                    </div>
                </Modal.Footer>
                <Loader loading={this.props.loading}/>
            </Modal>
        )
    }

    submitSetAssignee() {
        this.props.FaultActions.assignUser(this.props.fault.details.asset.id, this.props.fault.details.id, this.state.assignee,
            userHasActivity(this.props.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY)).then(() => {
            this.props.reloadFaultCondition()
            this.setState({assigneeModalOpen: false})
        }).catch((err) => {
            this.setState({assigneeModalOpen: false})
            if (err.generalError === false) {
                showNotification({
                    translationPropertyKey: 'fault.detail.action.assign.' + err.errorKey,
                    severity: "critical",
                });
            }
        })
    }

    getSelectOptions() {
        const {intl, fault} = this.props
        if (!fault.details.faultConditionState) {
            return []
        }
        let actionItems = []
        //state change actions only available for users with ASSIGNED_ISSUES_WRITE
        if (fault.details.access === ACCESS.WRITE) {
            actionItems = this.stateActions[fault.details.faultConditionState].map(a => {
                const assignedToOther = fault.details.assignedUser !== null && fault.details.assignedUser.id !== this.props.security.userProfile.id
                const disabled = !a.available || assignedToOther || fault.details.access !== ACCESS.WRITE
                return ({
                    value: a.action,
                    text: intl.formatMessage({id: "fault.detail.action." + a.action}),
                    disabled: disabled,
                })
            })
        }

        //Assign option should not be displayed at all when user does not have permission to assign fault
        if (!isClosedState(fault.details.faultConditionState) && fault.details.faultConditionState !== FAULT_STATES.DELETED && userHasActivity(this.props.security.userProfile, ACTIVITY_TYPES.TASKS_WRITE)) {
            actionItems.push({value: FAULT_ACTIONS.ASSIGN, text: intl.formatMessage({id: "fault.detail.action.assign"}), disabled: false})
        }
        return actionItems;
    }

    doOnChange(action) {
        const {fault} = this.props
        switch (action) {
            case FAULT_ACTIONS.START :
                this.changeFaultState(FAULT_STATES.IN_PROGRESS)
                break;
            case FAULT_ACTIONS.PUT_ON_HOLD :
                this.changeFaultState(FAULT_STATES.ON_HOLD)
                break;
            case FAULT_ACTIONS.CLOSE :
                if (fault.details.faultConditionState === FAULT_STATES.VERIFICATION) {
                    this.props.troubleshootingNavigation()
                } else {
                    this.setState({closeModalOpen: true})
                }
                break;
            case FAULT_ACTIONS.DELETE :
                this.changeFaultState(FAULT_STATES.DELETED).then(() => {
                    showNotification({
                        translationPropertyKey: 'fault.detail.delete.success',
                        severity: "success",
                        autoClose: false,
                    })
                })
                this.fetchCreatedFaults();
                break;
            case FAULT_ACTIONS.ASSIGN:
                this.setState({assigneeModalOpen: true})
                break;
            default:
                break;
        }
    }

    render() {
        const {intl} = this.props

        const actionItems = this.getSelectOptions()

        return (
            <div id="form-field" className={this.props.actionClassName}>
                <Select
                    text={intl.formatMessage({id: "fault.detail.button.actions"})}
                    options={actionItems}
                    value={null}
                    onChange={(data) => {
                        this.doOnChange(data)
                    }}
                    disabled={actionItems.length <= 0}
                >
                </Select>
                <CloseFaultModal
                    closeModalWindow={() => this.setState({closeModalOpen: false})}
                    closeModalOpen={this.state.closeModalOpen}
                    reloadFaultCondition={() => this.props.reloadFaultCondition()}
                    troubleshootingNavigation={() => this.props.troubleshootingNavigation()}
                />
                {this.assigneeModal()}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        loading: state.fault.fetchCount > 0,
        security: state.security,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(ActionsDropdown)))